import { render, staticRenderFns } from "./CiVehicleCard.vue?vue&type=template&id=0da549e0&"
import script from "./CiVehicleCard.vue?vue&type=script&lang=js&"
export * from "./CiVehicleCard.vue?vue&type=script&lang=js&"
import style0 from "./CiVehicleCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports